export const CourseTableHeader = [
  { name: 'index', label: '', isSortable: false, align: 'right' },
  { name: 'title', label: 'نام دوره', isSortable: true, align: 'center' },
  { name: 'createdAt', label: 'تاریخ ایجاد', isSortable: false, align: 'center' },
  { name: 'category', label: 'دسته بندی اصلی', isSortable: false, align: 'center' },
  { name: 'category', label: 'زیر مجموعه', isSortable: false, align: 'center' },
  { name: 'tags', label: 'برچسب ها', isSortable: false, align: 'center' },
  { name: 'minLevel', label: 'حداقل سطح دسترسی', isSortable: false, align: 'center' },
  { name: 'teacher', label: 'مدرس', isSortable: false, align: 'center' },
  { name: 'duration', label: 'مدت زمان', isSortable: false, align: 'center' },
  { name: 'absorption', label: 'دوره جذاب', isSortable: false, align: 'center' },
  { name: 'knowledge', label: 'بیزنالج', isSortable: false, align: 'center' },
  { name: 'status', label: 'وضعیت', isSortable: false, align: 'center' },
  { name: 'actions', label: '', isSortable: false, align: 'center' },
];
